module.exports = __webpack_public_path__ + "img/malerei1.2c0a58c7.jpg";